module.exports = __webpack_public_path__ + "img/pip2.815f0916.jpg";